export class Preloader {
  constructor() {
    this.el = document.getElementById('preloader')
    if (!this.el) return

    // DEV: désactiver pour toujours afficher le preloader
    // if (sessionStorage.getItem('preloaderSeen')) {
    //   this.el.style.display = 'none'
    //   return
    // }

    this.bg   = this.el.querySelector('.preloader__bg')
    this.logo = this.el.querySelector('.preloader__logo')
    this.text = this.el.querySelector('.preloader__text')
    this.veil = document.querySelector('.home-veil')
    this.exiting = false

    document.body.style.overflow = 'hidden'
    this.animate()
  }

  animate() {
    // t=0 : image fade in (2s)
    requestAnimationFrame(() => {
      if (this.bg) this.bg.classList.add('is-visible')
    })

    // t=600ms : logo
    setTimeout(() => {
      if (this.logo) this.logo.classList.add('is-visible')
    }, 600)

    // t=1100ms : texte
    setTimeout(() => {
      if (this.text) this.text.classList.add('is-visible')
    }, 1100)

    // t=2000ms (fin des animations) + 5s de pause = 7s avant exit
    this.timer = setTimeout(() => this.exit(), 3500)

    this.el.addEventListener('click', () => this.exit())
    this._onKey = (e) => { if (e.key === 'Escape') this.exit() }
    document.addEventListener('keydown', this._onKey)
  }

  exit() {
    if (this.exiting) return
    this.exiting = true
    clearTimeout(this.timer)

    document.removeEventListener('keydown', this._onKey)

    // preloader disparaît en premier
    this.el.classList.add('is-done')

    // voile visible 1s puis fade out
    setTimeout(() => {
      if (this.veil) this.veil.classList.add('is-done')
    }, 500)

    // nettoyage après la fin du fade out du voile (1s + 1.4s transition)
    setTimeout(() => {
      this.el.style.display = 'none'
      document.body.style.overflow = ''
      sessionStorage.setItem('preloaderSeen', '1')
    }, 2500)
  }
}
